import React from 'react';
import {
  InputGroup,
  FormControl
} from "react-bootstrap";
import { GrFormSearch } from "react-icons/gr";

export const ColumnFilter = ({column}) => {
    const { filterValue, setFilter } = column;
  return (
    <div>
      <InputGroup className="mb-2">
        {/* <InputGroup.Text id="basic-addon1">
          <GrFormSearch />
        </InputGroup.Text> */}
        <FormControl
          value={filterValue || ""}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Filter..."
          aria-label="Username"
          aria-describedby="basic-addon1"
        />
      </InputGroup>
    </div>
  );
};
export default ColumnFilter;
// import React from "react";

// export const ColumnFilter = ({ column }) => {
//   const { filterValue, setFilter } = column;
//   return (
//     <span>
//       Search:{" "}
//       <input
//         value={filterValue || ""}
//         onChange={(e) => setFilter(e.target.value)}
//       />
//     </span>
//   );
// };